import constants from "../helpers/en"

export const ERROR_CODE_MESSAGES = {
  400: constants.ERROR_400_API_MESSAGE,
  401: constants.ERROR_401_API_MESSAGE,
  403: constants.ERROR_403_API_MESSAGE,
  404: constants.ERROR_404_API_MESSAGE,
  405: constants.ERROR_405_API_MESSAGE,
  406: constants.ERROR_406_API_MESAGE,
  500: constants.ERROR_500_API_MESSAGE,
  501: constants.ERROR_501_API_MESSAGE,
  502: constants.ERROR_502_API_MESSAGE,
  503: constants.ERROR_503_API_MESSAGE,
  504: constants.ERROR_504_API_MESSAGE,
  UNKNOWN: constants.ERROR_UNKNOWN_API,
}

export const handleApiError = (error, toast) => {
  let code = error?.response?.data?.errorCode

  // Normalize: Remove prefixes like SFDC-400 → 400, DB-501 → 501
  if (typeof code === "string" && code.includes("-")) {
    code = code.split("-")[1]
  }

  const normalizedCode = code?.toString() || "UNKNOWN"

  let message =
    ERROR_CODE_MESSAGES[normalizedCode] || ERROR_CODE_MESSAGES.UNKNOWN

  // ✅ Special handling for 501 DB constraint errors
  if (normalizedCode === "501") {
    const detailedDesc = error?.response?.data?.detailedDescription || ""

    const fkMatch = detailedDesc.includes("facility_details")
    const fUserMatch = detailedDesc.includes("email")
    if (fkMatch) {
      message = constants.ERROR_500_MESSAGE
    } else if (fUserMatch) {
      message = "User already onboarded."
    } else {
      message = ERROR_CODE_MESSAGES["501"] || message
    }
  }

  if (toast?.showError) {
    toast.showError(message)
  } else if (toast?.error) {
    toast.error(message)
  } else {
    console.error("Toast not initialized:", message)
  }

  return message
}
